import { render, staticRenderFns } from "./TouchInBagInfo.vue?vue&type=template&id=99cadeda&scoped=true"
import script from "./TouchInBagInfo.vue?vue&type=script&lang=js"
export * from "./TouchInBagInfo.vue?vue&type=script&lang=js"
import style0 from "./TouchInBagInfo.vue?vue&type=style&index=0&id=99cadeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cadeda",
  null
  
)

export default component.exports